import { render } from "./SongTable.vue?vue&type=template&id=50f912ed&scoped=true"
import script from "./SongTable.vue?vue&type=script&lang=js"
export * from "./SongTable.vue?vue&type=script&lang=js"

import "./SongTable.vue?vue&type=style&index=0&id=50f912ed&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/acnh-tracker/acnh-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f912ed"]])

export default __exports__